import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackService, FeedbackServiceImpl } from '@analytics/shared/components/feedback/feedback.service';

export const feedbackSingletonModule = (bind: interfaces.Bind) => {
    bind(FeedbackService).to(FeedbackServiceImpl);
};

export const feedbackRequestModule = (bind: interfaces.Bind) => {
    bind(FeedbackService).to(FeedbackServiceImpl).inRequestScope();
};
